import React,{useEffect, useState} from 'react';
import './blackScreen.css';

function BlackScreen({txt,goNext,end,setAskCount,setMistakes,setFailedGame,reset,resetFgameToFalse,setPlotLine, first}) {
  const [white, setWhite] = useState(1);
  const [clicked, setClicked] = useState(true);

  useEffect(() => {
    if(reset===true){
      localStorage.setItem('askCount', 0);
      localStorage.setItem('mistakes', 0);
      localStorage.setItem('failedGame', 0);
      localStorage.setItem('plotLine', 0);
      setPlotLine(0)
      setAskCount(0);
      setMistakes(0);
      setFailedGame(0)
    }
    if(resetFgameToFalse===true){
      localStorage.setItem('askCount', 0);
      localStorage.setItem('mistakes', 0);
      localStorage.setItem('failedGame', 1);
      localStorage.setItem('plotLine', 0);
      setPlotLine(0)
      setAskCount(0);
      setMistakes(0);
      setFailedGame(1)
    }
    changeWhite(true);
},[]);

  useEffect(() => {
changeWhite(true);
},[txt]);

  async function go(){

    await goo();


       function goo(){
            return new Promise( async (resolve, reject) => {
              setClicked(false);
              if(end){
                localStorage.setItem('step', 0);
              }
              await changeWhite();
              goNext();
                resolve();
              });
            }

  }

  function changeWhite(toLow){
    return new Promise((resolve, reject) => {
    if(toLow){
      var op=1;
      change(toLow);
    }else{
      var op=0;
      change();
    }
    function change(toLow){
    if(toLow){
      if(op>0){
        op-=0.03;
      setWhite(op);
      setTimeout(ChangetoLow, 10);
    }else{
      resolve();
      return;
    }
  }else{
    if(op<1){
      op+=0.03;
    setWhite(op);
    setTimeout(change, 10);
  }else{
    resolve();
    setClicked(true);
    return;
  }
  }

  function ChangetoLow(){
     change(true);
  }
  }
  });
  }

return(
<div className='blkscrn'>
<div className='clickWrap' onClick={clicked? go : undefined} id='wrap' style={{opacity:white}}></div>
<div style={{width:"100vw"}}>
<h1 className='txt'>{txt}</h1>
{end && <a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button" style={{clear:"both",zIndex:"20"}}>CHECK 'EM OUT</div></a>}
{first && <a href='https://almondraf.itch.io/nsfw-job-christmas-episode' target="_blank"><div className="button" style={{clear:"both",zIndex:"20"}}>Christmas special</div></a>}
</div>
</div>
);

}

export default BlackScreen;
